import React, { useState } from 'react';
import { api } from '../../api/client';
import '../../styles/admin.css';

import { ta } from '../../i18n/adminT';
export default function AdminLogin({ onLoginSuccess }) {
  const [step, setStep] = useState('credentials'); // credentials | verify-totp | forgot-password
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [tempToken, setTempToken] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotSent, setForgotSent] = useState(false);

  const handleCredentials = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const res = await api.login(username, password);
      if (res.status === 'ok') {
        // Nessuna 2FA attiva su questo account: sessione già completa dopo la sola password
        onLoginSuccess();
        return;
      }
      setTempToken(res.tempToken);
      setStep('verify-totp');
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await api.verify2fa(tempToken, code);
      onLoginSuccess();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  const handleForgotSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await api.forgotPassword(forgotEmail);
      setForgotSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="lock-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect x="5" y="10" width="14" height="10" rx="2" stroke="#F6F5F1" strokeWidth="1.8"/><path d="M8 10V7a4 4 0 018 0v3" stroke="#F6F5F1" strokeWidth="1.8"/></svg>
        </div>

        {step === 'credentials' && (
          <>
            <h2>{ta('Accesso amministratore')}</h2>
            <p className="modal-subtitle">{ta('Area riservata.')}</p>
            {error && <div className="form-error">{error}</div>}
            <form onSubmit={handleCredentials}>
              <div className="field">
                <label htmlFor="username">{ta('Username')}</label>
                <input id="username" type="text" value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" />
              </div>
              <div className="field">
                <label htmlFor="password">{ta('Password')}</label>
                <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
              </div>
              <button className="btn btn-primary" disabled={busy}>{busy ? ta('Verifica…') : ta('Continua')}</button>
            </form>
            <button
              type="button"
              className="doc-link-btn"
              style={{ display: 'block', margin: '16px auto 0' }}
              onClick={() => { setStep('forgot-password'); setError(''); setForgotSent(false); }}
            >
              {ta('Password dimenticata?')}
            </button>
          </>
        )}

        {step === 'forgot-password' && (
          <>
            <h2>{ta('Recupera la password')}</h2>
            {forgotSent ? (
              <>
                <p className="modal-subtitle">
                  {ta('Se l\'indirizzo inserito corrisponde a un account amministratore, riceverai a breve un\'email con le istruzioni per impostare una nuova password.')}
                </p>
                <button type="button" className="btn btn-primary" onClick={() => setStep('credentials')}>{ta('Torna al login')}</button>
              </>
            ) : (
              <>
                <p className="modal-subtitle">{ta('Inserisci l\'email del tuo account: ti invieremo un link per reimpostare la password.')}</p>
                {error && <div className="form-error">{error}</div>}
                <form onSubmit={handleForgotSubmit}>
                  <div className="field">
                    <label htmlFor="forgot-email">{ta('Email')}</label>
                    <input
                      id="forgot-email"
                      type="email"
                      value={forgotEmail}
                      onChange={(e) => setForgotEmail(e.target.value)}
                      autoComplete="email"
                      autoFocus
                    />
                  </div>
                  <button className="btn btn-primary" disabled={busy}>{busy ? ta('Invio…') : ta('Invia link di reset')}</button>
                </form>
                <button
                  type="button"
                  className="doc-link-btn"
                  style={{ display: 'block', margin: '16px auto 0' }}
                  onClick={() => { setStep('credentials'); setError(''); }}
                >
                  {ta('Torna al login')}
                </button>
              </>
            )}
          </>
        )}

        {step === 'verify-totp' && (
          <>
            <h2>{ta('Verifica in due passaggi')}</h2>
            <p className="modal-subtitle">{ta('Inserisci il codice generato dalla tua app authenticator.')}</p>
            {error && <div className="form-error">{error}</div>}
            <form onSubmit={handleVerify}>
              <input
                type="text"
                inputMode="numeric"
                maxLength={6}
                className="totp-input"
                placeholder="000000"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                autoFocus
              />
              <button className="btn btn-primary" disabled={busy}>{busy ? ta('Verifica…') : ta('Accedi')}</button>
            </form>
          </>
        )}

        <p className="security-note">{ta('CONNESSIONE CIFRATA · SESSIONE PROTETTA')}</p>
      </div>
    </div>
  );
}
